import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { Pill } from '@/components';
import { CompAlertStatus } from '@/api';

import styles from './StatusBadge.module.sass';

interface StatusBadgeProps {
  value: CompAlertStatus;
  className?: string;
}

const StatusBadge = ({ value, className }: StatusBadgeProps) => {
  const { t } = useTranslation();

  const translations: Record<CompAlertStatus, string> = {
    new: t('translation.alert_status_new'),
    pending: t('translation.alert_status_pending'),
    rejected: t('translation.alert_status_rejected'),
    confirmed: t('translation.alert_status_confirmed'),
  };

  const label = translations[value];

  const classes = cx(
    styles.statusBadge,
    styles[`statusBadge--${value}`],
    className,
  );

  if (!label) {
    return null;
  }

  return <Pill text={label} tooltipText={label} className={classes} />;
};

export default StatusBadge;
